import { actionCreation } from '@anna/anna-ws-utils';

const { generateActionTypes, generateActions, makeActionCreator } = actionCreation;

export const getMoreTransactionsActionTypes = generateActionTypes('GET_MORE_TRANSACTIONS');

export const actionTypes = {
  UPDATE_DATES: 'UPDATE_DATES',
  UPDATE_TRANSACTION: 'UPDATE_TRANSACTION',
};

export const getMoreTransactionsActions = generateActions(
  getMoreTransactionsActionTypes,
  {
    success: ['transactions', 'transactionsList', 'totalTransactions'],
  },
);

export const updateDates = makeActionCreator(actionTypes.UPDATE_DATES, 'dates');

export const updateTransaction = makeActionCreator(actionTypes.UPDATE_TRANSACTION, 'transaction');
